import { useEffect } from 'react';
import { usePostMessage, useSubscribeData } from 'spectacle-ui-game-bridge-react';
import { getPath } from '../../config';
import Debug from '../../components/debug/debug';
import LoadingIndicator from '../../components/loadingIndicator/loadingIndicator';
import useContentForBuild from '../../hooks/useContentForBuild';
import useDebouncedDlogFunnel from '../../hooks/useDebouncedDlogFunnel';
import useDlogLoginFunnel, { LoginFunnelAction } from '../../hooks/useDlogLoginFunnel';
import VideoPlayer from '../../components/videoPlayer/videoPlayer';
import './postLogin.sass';

export default function PostLogin() {
  const [content, loading] = useContentForBuild();
  const dlog = useDlogLoginFunnel();
  const dlogVideoPlayed = useDebouncedDlogFunnel({
    phase: 'Video_Player_Active',
    action: 'Video_Started',
    targets: 'Postlogin',
    resume: false,
  });
  const dlogVideoLooped = useDebouncedDlogFunnel({
    phase: 'Video_Player_Active',
    action: 'Video_Started',
    targets: 'Postlogin',
    resume: true,
  });
  const dlogVideoStuttering = useDebouncedDlogFunnel({
    phase: 'Video_Player_Active',
    action: 'Video_Stuttering',
    targets: 'Postlogin',
  });
  const fenceMessage = useSubscribeData<string>('tos', 'fenceMessage');
  const fenceStatus = useSubscribeData<string>('tos', 'fenceStatus');
  const isInMainMenu = useSubscribeData<boolean>('tos', 'isInMainMenu');
  const closeWebView = usePostMessage('closeWebView');
  const heading = fenceMessage ?? content?.postLoginStatus;
  const message = fenceStatus ?? content?.postLoginMessage;

  // Once we are in the main menu, close this webview
  useEffect(() => {
    if (isInMainMenu) {
      closeWebView();
    }
  }, [isInMainMenu, closeWebView]);

  return (
    <>
      {loading && (
        <div className="loading-mask">
          <LoadingIndicator />
        </div>
      )}
      {content && (
        <div className="postlogin__status">
          <LoadingIndicator />
          <div className="postlogin__title">
            <h1>{heading}</h1>
            {message && <h2>{message}</h2>}
          </div>
        </div>
      )}
      <VideoPlayer
        src={getPath('video_cdni')}
        muted
        autoPlay
        loop
        cover
        volume={1}
        controls={false}
        onPlay={(event, looped) => (looped ? dlogVideoLooped() : dlogVideoPlayed())}
        onWaitingFirstTime={dlogVideoStuttering}
        onFinishedFirstPlaythrough={(event, stutterCount) =>
          dlog({
            phase: 'Video_Player_Active',
            action: `Video_Stuttered:${stutterCount}` as LoginFunnelAction,
            targets: 'Postlogin',
          })
        }
      />
      <div className="bg__overlay" />
      <Debug
        key="debug"
        enabled={!!content?.showDeveloperOverlay}
        vars={{
          isInMainMenu,
          fenceMessage,
          fenceStatus,
        }}
      >
        <button
          onClick={() => {
            closeWebView();
          }}
        >
          Close Webview
        </button>
      </Debug>
    </>
  );
}
